import React from "react"

import { Time } from "@tenforce/product-fields"

import { ITimeField } from "../.."
import { setCurrentFieldInEditMode, updateField } from "../../slice"
import { useAppDispatch, useAppSelector } from "../../../../hooks"
import HTMLAndInternalLinkParser from "../common/HTMLAndInternalLinkParser"
import { Labels } from "../../../../util/Translations"
import { GlobalState } from "../../../../store"

export interface Props {
    field: ITimeField
}

export const TimeField = ({ field }: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const {
        position: _position,
        odataType: _odataType,
        value,
        locale,
        timeZone,
        ...fieldProps
    } = field

    const { isLoading: isFieldLoading, currentFieldInEditMode = "" } =
        useAppSelector((state: GlobalState) => state.fields)

    const onSave = async (newValue: string): Promise<void> => {
        let valueToSave
        if (!newValue) {
            valueToSave = null
        } else {
            valueToSave = newValue
        }

        if (value === valueToSave) {
            return
        }

        await dispatch(
            updateField({
                field,
                newValue: valueToSave,
            }),
        ).unwrap()
    }

    const {
        ClickHereToEdit,
        PleaseEnterValidTime,
        PleaseEnterValidTimeUs,
        RequiredFieldErrorMessage,
    } = Labels

    const isLoading = fieldProps.isLoading || isFieldLoading

    const isDisabled =
        fieldProps.isDisabled ||
        !["", fieldProps.fieldId].includes(currentFieldInEditMode)

    return (
        <Time
            {...fieldProps}
            description={
                <HTMLAndInternalLinkParser
                    content={(field?.description as string) ?? ""}
                />
            }
            value={value}
            locale={locale}
            timeZone={timeZone}
            placeholder={ClickHereToEdit}
            mandatoryErrorText={RequiredFieldErrorMessage}
            onSave={onSave}
            labels={{
                PleaseEnterAValidTime:
                    locale === "en"
                        ? PleaseEnterValidTimeUs
                        : PleaseEnterValidTime,
            }}
            isLoading={isLoading}
            isDisabled={isDisabled}
            onFieldEnterEditMode={(fieldId): void => {
                dispatch(
                    setCurrentFieldInEditMode(fieldId ?? fieldProps.fieldId),
                )
            }}
            onFieldExitEditMode={(): void => {
                dispatch(setCurrentFieldInEditMode(""))
            }}
        />
    )
}

export default TimeField
